// import { useCallback } from "react";
import { useShallow } from 'zustand/react/shallow'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
// import type { LiveGiftsAnimations } from "../../../types/lives/animations";
import type { NotifyGift } from '../../../types/lives/notifies'

const LIVE_GIFTS_SENTS = '/LIVE-GIFTS-SENTS'

export const useUpdateToastEarnedGlobal = () => {
  const liveId = useGlobalStore(useShallow((state) => state.liveId))
  const liveCountry = useGlobalStore(useShallow((state) => state.liveCountry))

  const { addNotifyGiftToastEarned } = useGlobalStore(
    useShallow((state) => ({
      addNotifyGiftToastEarned: state.addNotifyGiftToastEarned,
    })),
  )

  const notifies = (notifyGiftSent: NotifyGift) => {
    const topGlobal = notifyGiftSent?.message?.topGlobal
    const topSameCountry = notifyGiftSent?.message?.topSameCountry
    const topLocal = notifyGiftSent?.message?.topLocal

    const id = Date.now()

    if (topGlobal && topGlobal?.type === 'earned') {
      return addNotifyGiftToastEarned({ ...notifyGiftSent, id })
    }

    if (topSameCountry && topSameCountry?.type === 'earned') {
      return addNotifyGiftToastEarned({ ...notifyGiftSent, id })
    }

    if (topLocal && topLocal?.type === 'earned') {
      addNotifyGiftToastEarned({ ...notifyGiftSent, id })
    }
  }

  useSub<NotifyGift>({
    endpoint: `${LIVE_GIFTS_SENTS}/all`,
    skip: !liveId,
    // onData: notifies,
    onData: notifies,
  })

  useSub<NotifyGift>({
    endpoint: `${LIVE_GIFTS_SENTS}/${liveCountry}`,
    skip: !liveCountry,
    onData: notifies,
  })

  useSub<NotifyGift>({
    endpoint: `${LIVE_GIFTS_SENTS}/${liveId}`,
    skip: !liveId,
    onData: notifies,
  })
}
